import { useCallback } from 'react'
import { toast } from 'sonner'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches a presigned download URL and opens the file in a new tab. */
export function FileDownloadLink({ fileId, fileName }: { fileId: string; fileName: string }) {
  const api = useOsApi()

  const handleClick = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation()
      e.preventDefault()
      const res = await api.get('/files/:fileId/download-url', { params: { fileId } })
      if (res.success) window.open(res.data.downloadUrl, '_blank')
      else {
        console.error('Failed to fetch download URL', fileId)
        toast.error('Failed to download file')
      }
    },
    [api, fileId]
  )

  return (
    <button
      type="button"
      className="text-left text-primary underline underline-offset-2 cursor-pointer"
      onClick={handleClick}
    >
      {fileName}
    </button>
  )
}
